import { Spinner } from "@heroui/react";

function LoaderOverlay({
    children,
    isLoading,
}: {
    children: React.ReactNode;
    isLoading: boolean;
}) {
    if (!isLoading) {
        return children;
    }
    return (
        <div className="relative">
            {children}
            {isLoading && (
                <div className="absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center opacity-100 bg-opacity-90 bg-white">
                    <Spinner
                        size="sm"
                        className="opacity-100"
                        color="secondary"
                    />
                </div>
            )}
        </div>
    );
}

export default LoaderOverlay;
